import { capitalCase } from "change-case"
import { getCompletionAction } from "../../../completion/utils"
import { TreeNode } from "../../state/tree/path-tree"

const What = ({
  item,
  hideObject = false,
  hideVerb = false
}: {
  item: TreeNode<"completion">
  hideObject?: boolean
  hideVerb?: boolean
}) => {
  const object = item.data.name
  const verb = getCompletionAction(item.data.completion)
  return (
    <span className="Completion--What">
      {!hideVerb ? capitalCase(verb) : null}
      {!hideObject ? ` ${object}` : ""}
    </span>
  )
}

export default What
